import React, { Component } from 'react';
import FormExplanationValidation from './FormExplanationValidation';
import { getJsonItem } from '../Utilities/JsonFunctions.js'

class FormSelect extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.onChange(e);
    }

    render() {
        let requiredMark = this.props.required && !this.props.readonly ? <span className="required-mark">*</span> : null;

        let selectedItem = getJsonItem(this.props.data, "key", this.props.value);
        let selectedText = selectedItem == null ? "" : selectedItem.value;

        return (
            <div className="tr">
                <div className="FieldLabel td">
                    <label htmlFor={this.props.readonly ? null : this.props.id}>{this.props.text}
                        {requiredMark}
                    </label>
                </div>
                {
                    (this.props.readonly) ?
                        <div className="EditingFormValueCell td"><p className="form-control-static">{selectedText}</p></div> :
                        <div className="EditingFormValueCell td">
                            <select id={this.props.id} disabled={this.props.disabled} autoComplete="no-autocomplete" ref={el => this.el = el}
                                className="form-control" onChange={this.onChange} value={this.props.value}>
                                {
                                    (this.props.emptyValue) ?
                                        <option value="-1">{this.props.emptyValue}</option> :
                                        ""
                                }
                                {
                                    (this.props.data == null) ?
                                        "" :
                                        this.props.data.map((option) =>
                                            <option key={option.key} value={option.key} disabled={option.disabled}>{option.value}</option>
                                        )
                                }
                            </select>
                            <FormExplanationValidation id={this.props.id} explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />                        
                        </div>        
                }
            </div>
        );
    }
}

export default FormSelect;


// WEBPACK FOOTER //
// ./src/Fields/FormSelect.js